import ASS from "./../../services/aanwezigheden-secundair.service.js";

// import * as mutationTypes from "./../../store/mutation-types.js";
import * as types from "./../../store/mutation-types.js";
import * as globalMutationTypes from "@/store/mutation-types.js";
import AS from "./../../services/agenda-global/agenda.service.js";
import basicOperations from "@/mixins/basic-operations.js";
import dateOperations from "@/mixins/date-operations.js";
import icons from "@/mixins/icons.js";
import RSM from "wisaapp-webstudent/src/mixins/right-side-menu.js";
import _ from "lodash";
import DropdownInPlace from "@/components/utils/dropdown-in-place/dropdown-in-place.vue";
import * as mutationTypes from "@/store/mutation-types.js";
// import smkGrid from '@/components/utils/smk-Grid/smk-Grid.vue';
import globalStore from "@/store/index.js";

class onlineServer {
  constructor(payload) {
    this.ClientID = payload.ClientID;
    this.ClientSecret = payload.ClientSecret;
    this.Commentaar = payload.Commentaar;
    this.Domein = payload.Domein;
    this.ID = payload.ID;
    this.TypeSysteem = payload.TypeSysteem;
  }

}
export default {
  name: "configuratie",
  mixins: [icons, basicOperations, dateOperations, RSM],
  components: {
    DropdownInPlace
    // ,
    // smkGrid
  },

  beforeDestroy: function() {},
  data() {
    return {
      configInfo: {},
      externalServerInfo: {
        Facebook: {},
       Google: {},
      Office365: {}
    },
    externalServerDomeinOptions:[],
      serverModules:[],
      saveChanges:'',
      typeLogs:{
        selected:'Website logs',
        apacheLogs:[],
        websiteLogs:[]
      },
    };
  },
updated(){
 
},
  beforeCreate() {
    let veranderpaswoord = this.$store.state.userInfo.loggedInUserInformation.UserData.veranderpaswoord;
    // eslint-disable-next-line
    if (Object.keys(WISA).length === 0 || veranderpaswoord || veranderpaswoord === undefined) {
      this.$router.push("/");
    }

  },
  created() {
    this.$store.commit("wstudent/" + types.ZET_CURRENT_SCREEN, "configuratie");
    this.getChangeServerIniFiles();
    this.initializeQueries();

  },

  watch: {},
  computed: {
    selectedLog(){
      if( this.typeLogs.selected === 'Website logs'){
        return this.typeLogs.websiteLogs
      }
      else if( this.typeLogs.selected === 'Apache logs'){
        return this.typeLogs.apacheLogs
      } 
      else{
        return []
      }


    }
    
  },
 
  mounted: function() {
    this.isClassActive()
    this.$store.commit(globalMutationTypes.SET_MENUBAR_ITEMS, {
      changePartially: true,
      left: "menu",
      // title: titelWaarde,
      title: "Configuratie",
      right: []
    });
  },
  methods: {
    updateAzureDomein (object) {
     console.log(object)
     this.configInfo.AzureDomein = object.Domein
     this.externalServerInfo.Office365.ClientID = object.ClientID 
     this.externalServerInfo.Office365.ClientSecret = object.ClientSecret 
     this.externalServerInfo.Office365.ID = object.ID 
     this.externalServerInfo.Office365.Domein = object.Domein 
    },
    isEmpty(value){
  if (!value){
    this.configInfo.AzureDomein=''
    this.configInfo.AzureDomeinID=''
  }
    },
 
    forceFileDownload(result){
     const url = window.URL.createObjectURL(new Blob([result.data]))
     const link = document.createElement('a')
     link.href = url
     link.setAttribute('download', 'test.log') //or any other extension
     document.body.appendChild(link)
     link.click()
   },
    downloadLog(logChosed){
      // globalStore.dispatch("wstudent/" + "downloadLogFileInfo",logChosed).then(result => {
      //   this.forceFileDownload(result[0].data.data)
          // });
      let path = window.location;
      let origin = path.origin;
      let serverLocation='';
      let pathname = path.pathname;
      let arrayPathname = pathname.split("/");
       let index =''
       if (arrayPathname.length>0){
  
        index = arrayPathname.indexOf("webstudent");
       }
       if (index === -1 || index==='-1' ){
         serverLocation = origin
       }else{
         serverLocation = origin + '/webstudent'
       }
   return serverLocation+'/bin/filemanager.cgi/Files/Logs/'+logChosed.Path+'?attachment=true/'
    // return ' https://dev2.schoolware.be/webstudent/bin/filemanager.cgi/Files/Logs/webstudent-2020-01-09-002.log?attachment=true/'
    //filemanager.cgi/Files/Logs/webstudent-2020-01-09-002.log?attachment=true/"

    },

    isClassActive(){
      let self = this
      $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        var target = $(e.target).attr("href") // activated tab
       
        self.saveChanges= (target==='#contact' )  || (target==='#logboek')
        
      });
    },
    putExternSysteem(){
      // this.externalServerInfo.Office365.ID=
      for (let key in  this.externalServerInfo){
        if( this.externalServerInfo.hasOwnProperty(key)){
          if(!_.isEmpty(this.externalServerInfo[key])){
      globalStore.dispatch("wstudent/" + "putExternSysteem",this.externalServerInfo[key]).then(result => {
        // console.log(result)
     
      });
    }
  }
  }
    }
    ,
    initializeQueries() {
      globalStore.dispatch("wstudent/" + "externSysteem").then(result => {
        let self =this
        self.externalServerDomeinOptions = result[0].data.data.filter(function(e) {
         
          return e.TypeSysteem === 'Office365' 
        })
      //  }).map(e => e.Domein);
        // self.externalServerDomeinOptions = self.externalServerDomeinOptions.map(e => e.Domein)
        if(self.externalServerDomeinOptions===undefined || self.externalServerDomeinOptions.length===0 ){
          self.configInfo.Office365Login=false
        }
          for (let x in  self.externalServerInfo){
            if( self.externalServerInfo.hasOwnProperty(x)){
            for( let i=0; i<result[0].data.data.length;i++){
          if(result[0].data.data[i].TypeSysteem===x){
            self.externalServerInfo[x] = new onlineServer(result[0].data.data[i]);

          }
          }
        }

        }
      
      });
      globalStore.dispatch("wstudent/" + "websiteModule").then(result => {
        this.serverModules=result[0].data.data
      });
      globalStore.dispatch("wstudent/" + "logFileInfo",'Logs').then(result => {
        this.typeLogs.websiteLogs=result[0].data.data
      });
      globalStore.dispatch("wstudent/" + "logFileInfo",'ApacheLogs').then(result => {
        this.typeLogs.apacheLogs=result[0].data.data
       });
    },
    getChangeServerIniFiles() {
      let self = this;
      globalStore.dispatch("wstudent/" + "GetServerIniFile").then(result => {
        console.log(result);
        if (result.data.error === null) {
          console.log(result);
          self.configInfo = result.data.result;
        }
      });
    },
    setChangeServerIniFiles() {
      this.putExternSysteem()
      let a = [
        {
          InstellingsCode: this.configInfo.InstellingsCode,
          SchoolNaam: this.configInfo.SchoolNaam,
          SchoolStraat: this.configInfo.SchoolStraat,
          SchoolTelefoon: this.configInfo.SchoolTelefoon,
          SchoolEmail: this.configInfo.SchoolEmail,
          SchoolFax: this.configInfo.SchoolFax,
          SchoolGemeente: this.configInfo.SchoolGemeente,
          KanMijnGegevensBewerken: this.configInfo.KanMijnGegevensBewerken,
          ToonMijnGegevens: this.configInfo.ToonMijnGegevens,
          ToonAgenda: this.configInfo.ToonAgenda,
          ToonAanwezigheden: this.configInfo.ToonAanwezigheden,
          ToonOpleiding: this.configInfo.ToonOpleiding,
          ToonBetalingen: this.configInfo.ToonBetalingen,
          //ToonG: this.configInfo.ToonG,
      //sms provider gegevens
          AccountSMSProvider:this.configInfo.AccountSMSProvider,
          AccountSMSProviderClientID:this.configInfo.AccountSMSProviderClientID,
          AccountSMSProviderClientSecret:this.configInfo.AccountSMSProviderClientSecret,
          AccountSMSProviderDefaultText:this.configInfo.AccountSMSProviderDefaultText,
          AccountSMSProviderSender:this.configInfo.AccountSMSProviderSender,
          AccountSMSProviderURL:this.configInfo.AccountSMSProviderURL,

       /****************************** */
          WebsiteNaam: this.configInfo.WebsiteNaam,
          //to change
          Logging: this.configInfo.Logging,
          FaceBookLogin: this.configInfo.FaceBookLogin,
          GoogleLogin: this.configInfo.GoogleLogin,
          Office365Login: this.configInfo.Office365Login,
          AzureDomein: this.configInfo.AzureDomein,
          WisaWebSiteID: 0,
          LogType: "Logs",
          currentpassword: "",
          BaseURL:this.configInfo.BaseURL,
          BlockAccountCreation:this.configInfo.BlockAccountCreation
        }
      ];
      globalStore.dispatch("wstudent/" + "changeServerIniFile", a).then(result => {
        console.log(result);
        if (result === null) {
          this.$store.commit(mutationTypes.SHOW_MESSAGE, ["Uw informatie is gewijzigd"], {
            root: true
          });
        }
      });
    }
  }
};
